import { buildWidgetPlugin } from "public/lib";

$w.onReady(async () => {
    await buildWidgetPlugin({ 
        $element: $w('#allReviewsElement'), 
        $widget,
        typeName: "All Reviews", 
        type: "all_reviews", 
        forProduct: false, 
        defaultSettings: {
            heading: "Reviews",
            layout: "masonry",
        }
    });
});
